import React from "react";
import warningIcon from "common-ui-components/components/icons/warning.svg";
import infoIcon from "../../app/settings/organization/activity log/icons/info.svg";

const BasicMessage = ({
  title,
  status,
  icon: customIcon,
  text,
  children,
  component,
}) => {
  if (component) {
    return component;
  }
  const icon = () => {
    if (status?.toLowerCase() === "info" || status?.toLowerCase() === "information") return infoIcon;
    else if (status?.toLowerCase() === "warning") return warningIcon;
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.3rem" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "1.15rem" }}>
        <img
          src={customIcon || icon()}
          alt="message"
          style={{ width: "1rem", height: "1rem", flexShrink: 0 }}
        />
        {title && <b style={{ margin: 0 }}>{title}</b>}
      </div>
      <div style={{ paddingLeft: "2.15rem" }}>
        {children ?? (text && <p style={{ margin: 0 }}>{text}</p>)}
      </div>
    </div>
  );
};

export default BasicMessage;
